import type { ImportRun, RunStatus } from '@/services/importacoes-service'
import { formatDateBr } from '@/lib/publication-inbox'

export const RUN_STATUS_LABELS: Record<RunStatus, string> = {
  EM_ANDAMENTO: 'Em andamento',
  CONCLUIDA: 'Concluída',
  CONCLUIDA_COM_ERROS: 'Concluída com erros',
  FALHOU: 'Falhou',
}

export function runStatusVariant(status: RunStatus): 'default' | 'secondary' | 'destructive' | 'outline' {
  if (status === 'FALHOU') return 'destructive'
  if (status === 'CONCLUIDA_COM_ERROS') return 'outline'
  if (status === 'EM_ANDAMENTO') return 'secondary'
  return 'default'
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return iso
  return date.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short', timeZone: 'America/Sao_Paulo' })
}

export function runPeriodLabel(run: Pick<ImportRun, 'dataInicio' | 'dataFim'>): string {
  if (!run.dataInicio && !run.dataFim) return 'Padrão da API'
  return `${formatDateBr(run.dataInicio)} a ${formatDateBr(run.dataFim)}`
}
